import React from 'react';
import { TimelineContent, TimelineItem } from '@mui/lab';
import { Typography } from '@mui/material';
import { CustomTimelineSeparator } from '../Timeline/CustomTimeline';


const CustomProjectTimelineItem = ({p}) => {
    const { title, live, server, client, desc } = p
    return (
        <TimelineItem>
            <CustomTimelineSeparator />
            <TimelineContent >
                <Typography className="fw-bold fs-6">{title}</Typography>
                <Typography variant="caption" className="timeline-date">
                    {live && <a href={live} style={{ fontSize: '14px' }} className="me-2 fw-bold" target="_blank" rel="noopener noreferrer">Live</a>}
                    {server && <a href={server} style={{ fontSize: '14px' }} className="me-2 fw-bold" target="_blank" rel="noopener noreferrer">Server</a>}
                    {client && <a href={client} style={{ fontSize: '14px' }} className="me-2 fw-bold" target="_blank" rel="noopener noreferrer">Client</a>}
                </Typography> <br />
                <Typography variant="caption" className="timeline-description">{desc}</Typography>

            </TimelineContent>
        </TimelineItem>
    )
}

export default CustomProjectTimelineItem;